import { render } from "./ReminderModal.vue?vue&type=template&id=9786bab6"
import script from "./ReminderModal.vue?vue&type=script&lang=js"
export * from "./ReminderModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ReminderModal.vue"]])

export default __exports__